'use strict';

angular.module('adminDefaultEntitlementControllers')

.controller('BySystemRoleController', ['$scope', '$state', '$stateParams', 'businessSystemService', function ($scope, $state, $stateParams, businessSystemService, adminDefaultEntitlementService) {

    $scope.systemId = $stateParams.systemId;

    businessSystemService.getBusinessSystemForCard($scope.systemId)
                         .then(function (sysInfos) {
                             $scope.system = sysInfos;
                         });

    businessSystemService.getActiveSystemRolesByBusinessSystem($scope.systemId)
                         .then(function (systemRoles) {
                                $scope.systemRoles = systemRoles;
                         });
}]);
